import axios from 'axios'
import Alpine from 'alpinejs'
import install from './install.js'

window.axios = axios
window.Alpine = Alpine

Alpine.store('install', install)
Alpine.start()
